<template>
  <div>
    <div class="home-v2">
      <div class="home-bg">
        <img class="img-home-bg" src="../../../assets/img/home-bg.jpg" alt="">
      </div>
      <div class="home-v2__main-title">KEGIATAN USAHA UTAMA</div>
      <div class="home-v2__list" v-if="listUsaha">
        <div class="list-usaha" v-for="(list, index) in listUsaha" :key="index">
          <div>
            <div class="img-usaha" @click="gotoLevel1(list)">
              <img :src="require(`~/assets/img/icons/${list.id}.png`)" alt="">
            </div>
            <div class="desc-usaha">{{ list.desc }}</div>
          </div>
          <div 
            :class="`
              tooltips-usaha 
              ${(index + 1) == 6 || (index + 1) == 7 || (index + 1) == 13 || (index + 1) == 14 || (index + 1) == 20 || (index + 1) == 21 
                ? 'tooltips-usaha-1-7' 
                : 'tooltips-usaha-1-1'
              }
              ${(index + 1 ) > 14 ? 'tooltips-usaha-3' : 'tooltips-usaha-1'}
            `">
            <div class="popup-wrapper">
              <div class="popup-top">
                <div class="popup-top-title">{{list.alphabet }}. {{ list.desc }}</div>
                <div class="popup-top-search">
                  <form v-on:submit.prevent="noop">
                    <input type="text" placeholder="Cari Sub Kategori" v-model="subSeach[index]" @keyup="searchRun(list.id)"/>
                  </form>
                  <div @click="searchRun(list.id)"><strong class="search-icons"><i class="fas fa-search"></i></strong></div>
                </div>
              </div>
              <div class="popup-middle">
                <div class="popup-middle-wrapper" v-for="(sublist, index) in list.sub" :key="index">
                  <label><input type="checkbox" v-model="selectedSub" :value="sublist.id" style="margin-right: 20px">{{ sublist.kode }} - {{ sublist.desc }}</label>
                </div>
              </div>
              <div class="popup-bottom">
                <div class="popup-btn" @click="resetFilter()">RESET</div>
                <div class="popup-btn" @click="confirmSearch(list)">KONFIRMASI</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/config.js'
import axios from 'axios'

export default {
  data() {
    return {
      subSeach: [],
      selectedSub: [],
      listUsaha : [
        {
          name: 'Pertanian, Kehutanan, dan Perikanan',
          id: '1',
          sub: [
            {
              code : '00111',
              subName: 'Sub kategori 1'
            },
            {
              code : '00111',
              subName: 'Sub kategori 1'
            },
            {
              code : '00111',
              subName: 'Sub kategori 1'
            },
          ]
        },
        {
          name: 'Pertambangan dan Penggalian',
          id: '2',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Industri Pengolahan',
          id: '3',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Pengadaan Listrik, Gas, Uap/Air Panas dan Udara',
          id: '4',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Treatmen Air, Treatment Air Limbah, Treatment Udara',
          id: '5',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Konstruksi',
          id: '6',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Perdagangan Besar Dan Eceran, Reparasi dan Perbaikan',
          id: '7',
          sub: [
            {
              code : '00111',
              subName: 'Sub kategori 1'
            },
            {
              code : '00111',
              subName: 'Sub kategori 1'
            },
            {
              code : '00111',
              subName: 'Sub kategori 1'
            },
          ]
        },
        {
          name: 'Pengangkutan dan Pergudangan',
          id: '8',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Penyediaan Akomodasi dan Penyediaan Makanan dan Minuman',
          id: '9',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Informasi dan Komunikasi',
          id: '10',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Aktivitas Keuangan dan Asuransi',
          id: '11',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Real Estat',
          id: '12',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Aktivitas Profesional, Ilmiah dan Teknis',
          id: '13',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Aktivitas Penyewaan dan Sewa Guna Usaha dan Jasa',
          id: '14',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Administrasi Pemerintahan Pusat',
          id: '15',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Pendidikan',
          id: '16',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Aktivitas Kesehatan Manusia dan Aktivitas Mesin',
          id: '17',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Kesenian, Hiburan dan Rekreasi',
          id: '18',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Aktivitas Jasa Lainnya',
          id: '19',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Aktivitas Rumah Tangga Sebagai Pemberi Kerja kepada masyarakat',
          id: '20',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
        {
          name: 'Aktivitas Badan International dan Nasional',
          id: '21',
          sub: [
            {
              code : '',
              subName: ''
            },
          ]
        },
      ],
      listUsahaMaster: null
    }
  },
  created(){
    this.getKbliData()
    this.getKbliMaster() 
  },
  methods: {
    async getKbliData() {
      const url = `${api}/api/v1/kbli-parent?page=1&limit=3000`
      try {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        const { data } = await axios({
          method: 'GET',
          url
        })

        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        this.listUsaha = data.data
      } catch (error) {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        await this.$store.commit('SET_NOTIF', this.$get(error, 'response.data.message', 'Error'))
      }
    },
    async getKbliMaster() {
      const url = `${api}/api/v1/kbli-parent?page=1&limit=3000`
      try {
        const { data } = await axios({
          method: 'GET',
          url
        })
        this.listUsahaMaster = data.data
      } catch (error) {
        this.$store.commit('SET_NOTIF', this.$get(error, 'response.data.message', 'Error'))
      }
    },
    async searchRun(id) {
      const self = this
      const arrIndex = Number(id) - 1
      const search = String(self.subSeach[arrIndex])
      const list = self.listUsahaMaster[arrIndex].sub

      let filteredList = []
      for(let i in list) {
        if(list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      self.listUsaha[arrIndex].sub = filteredList
    },
    resetFilter() {
      this.selectedSub = []
    },
    async getDataLevel1(id, subId) {
      const self = this
      const subKbli = `${subId && subId !== 'undefined' ? this.paramsFormatter('kbli_sub',subId) : ''}`
      const parentKbli = id && `&kbli_parent=${id}`

      await self.$store.commit('level1/SET_DATA_LEVEL1', { query: {kbliSub: subKbli, kbliParent: parentKbli} })


      await self.$router.push('level1')
    },
    async gotoLevel1(item) {
      await this.$store.commit('level1/SET_STATUS_CATEGORY', `${item.alphabet}. ${item.desc}`)
      await this.getDataLevel1(item.id)
    },
    async confirmSearch(item) {
      await this.$store.commit('level1/SET_STATUS_CATEGORY', `${item.alphabet}. ${item.desc}`)
      await this.getDataLevel1(item.id, this.selectedSub)
    },
    noop() {
      //do nothing
    }
  }
}
</script>